export default __webpack_public_path__ + "static/media/back.863b84d6.svg";